/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext } from 'react'
import { getRequestOptions } from '../helpers/Fetchwrapper';
import { KTSVG } from '../../_metronic/helpers';
import { Col, Row, Table } from 'react-bootstrap-v5';
import 'react-dropzone-uploader/dist/styles.css'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone-uploader'
import Swal from 'sweetalert2'
import showLoader from '../helpers/ShowLoader';
import axios, { AxiosResponse, AxiosError } from 'axios'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import { AppContext } from '../context/AppContext'

interface PurchaseInfo {
    id_purchase: number;
    id_projects: number;
    id_vendors: number;
    purchaseType: string;
    purchaseDate: string;
    referenceNo: string;
    lcNo: string;
    invoiceNo?: string;
    chalanNo: string;
    chalanDate: string;
    remarks: string;
    purchaseAmount: number;
    itemAmount?: number;
    vat?: number;
    tax?: number;
    vatAmount?: number;
    taxAmount?: number;
    created_by: number;
    createdAt: string;
    project: {
        id_projects: number;
        projectName: string;
    };
    warehouse: { id_warehouses: number, name: string, address: string, details: string };
    vendor: { id_vendors: number, vendorName: string, phone: string, address: string };
    voucher: { id_acc_vouchers: number, voucherNo: string, voucherDate: string, voucherType: string };
    rows: { id_purchase: number, id_items: number, rate: number, quantity: number, returnQuantity: number, item: any }[];
    files: { id_ref: number, refType: string, attachmentName: string, attachmentPath: string, fileSize: number, created_at: string, creator: any }[];
    creator: any;
    status: string;
}

interface RouteParams {
    idPurchase: string;
}

export function PurchaseDetails(props: any) {

    const { currentUser } = useContext(AppContext);
    const [purchaseInfo, setPurchaseInfo] = useState<PurchaseInfo | null>(null);
    const { idPurchase }: RouteParams = useParams();

    useEffect(() => {
        if (idPurchase !== undefined) {
            getPurchaseInfo();
        }
    }, [idPurchase])

    const getPurchaseInfo = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'purchase/' + idPurchase,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                const data: PurchaseInfo = resp.data;
                setPurchaseInfo(data);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }


    const numberFormat = (value: any) => {

        value = parseFloat(value)
        if (typeof (value) !== 'number') {
            return value;
        }
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }


    const getReadableFileSizeString = (fileSizeInBytes: number) => {
        return ((fileSizeInBytes / (1024 * 1024)).toFixed(4) + " MB");
    }

    const jwt = () => {
        const myToken = localStorage.getItem('MyToken');
        return (myToken != null) ? JSON.parse(myToken) : null;
    }

    const handleFileSubmit = (files: any, allFiles: []) => {
        showLoader()

        const postFormData = new FormData();
        postFormData.append('idRef', idPurchase.toString());
        postFormData.append('refType', 'goods_receive');
        postFormData.append('folderPath', 'goods-receives');
        for (let i = 0; i < files.length; i++) {
            postFormData.append('files[]', files[i].file);
        }

        const url: string = `${process.env.REACT_APP_API_URL}file/upload`;

        axios({
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'Bearer ' + jwt(),
            },
            data: postFormData,
        })
            .then((response: AxiosResponse<any>) => {
                Swal.close();
                allFiles.forEach((f: any) => f.remove());
                getPurchaseInfo();
            })
            .catch((error: AxiosError<any>) => {
                Swal.close();
                // const errorMessage: string = error.response?.data?.errorMessage;
                const errorsMessage: string = validationErrorMsg(error?.response?.data?.errors).join('<br>');
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: errorsMessage,
                });
            });

    }

    return (<>
        <div className='card card-custom'>
            <div className='card-header card-header-stretch overflow-auto'>
                <div className='card-title'>
                    <h3 className='card-label'>Goods Received Details</h3>
                    <small className='text-muted'>| Information about the Goods Received</small>
                </div>
            </div>
            <div className="card-body">

            </div>
        </div>
        <Row>
            <Col md={4} className="pe-2">
                <div className="card card-flush overflow-hidden mt-3 ms-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Summary</span>
                        </h3>
                    </div>
                    <div className="card-body pt-0">
                        <Table striped bordered hover size='sm'>
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%' }}>ID</td>
                                    <td style={{ width: '50%' }}>{purchaseInfo?.id_purchase}</td>
                                </tr>
                                <tr>
                                    <td>Receive Type</td>
                                    <td>
                                        {
                                            purchaseInfo?.purchaseType === 'LC' ?
                                                <span className="badge badge-primary">LC</span>

                                                :
                                                <span className="badge badge-success">Local Purchase</span>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>PO Purpose</td>
                                    <td>
                                        <span className={`badge ${purchaseInfo?.po?.purpose === 'Finished Product' ? 'badge-info' : 'badge-success'}`}>
                                            {purchaseInfo?.po?.purpose || 'Raw Materials'}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Project</td>
                                    <td>{purchaseInfo?.project?.projectName}</td>
                                </tr>
                                <tr>
                                    <td>Warehouse</td>
                                    <td>{purchaseInfo?.warehouse?.name}</td>
                                </tr>
                                <tr>
                                    <td>Vendor</td>
                                    <td>{purchaseInfo?.vendor?.vendorName}</td>
                                </tr>
                                <tr>
                                    <td>Receive Date </td>
                                    <td>{purchaseInfo?.purchaseDate}</td>
                                </tr>
                                <tr>
                                    <td>Reference No </td>
                                    <td>{purchaseInfo?.referenceNo}</td>
                                </tr>
                                {
                                    purchaseInfo?.purchaseType === 'LC' && (
                                        <>
                                            <tr>
                                                <td>LC No</td>
                                                <td>{purchaseInfo?.lcNo}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoice No</td>
                                                <td>{purchaseInfo?.invoiceNo}</td>
                                            </tr>
                                        </>
                                    )
                                }

                                <tr>
                                    <td>Chalan No</td>
                                    <td>{purchaseInfo?.chalanNo}</td>
                                </tr>
                                <tr>
                                    <td>Chalan Date</td>
                                    <td>{purchaseInfo?.chalanDate}</td>
                                </tr>
                                <tr>
                                    <td>Voucher No </td>
                                    <td>
                                        <span>{purchaseInfo?.voucher?.voucherNo} </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Status </td>
                                    <td>
                                        {purchaseInfo?.status === 'approved' && <span className="badge badge-success">Approved</span>}
                                        {purchaseInfo?.status === 'created' && <span className="badge badge-warning">Pending for Accountant Approval</span>}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Remarks</td>
                                    <td>{purchaseInfo?.remarks}</td>
                                </tr>
                                <tr>
                                    <td>Creator</td>
                                    <td>{purchaseInfo?.creator.firstName + ' ' + purchaseInfo?.creator.lastName + ' at ' + purchaseInfo?.createdAt}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className='card card-flush overflow-hidden mt-3 ms-2'>
                    <div className='card-header py-5'>
                        <h3 className="card-title">
                            <KTSVG className='svg-icon-3 me-2' path="/media/svg/icons/General/Clip.svg"></KTSVG>
                            Attach files
                        </h3>
                    </div>


                    <div className='card-body'>
                        <Table striped bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th style={{ width: '50%' }}>Attachment</th>
                                    <th style={{ width: '50%' }}>Uploaded By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {purchaseInfo?.files?.length === 0 &&
                                    <tr>
                                        <td colSpan={2}>No File Attached</td>
                                    </tr>
                                }
                                {purchaseInfo?.files?.map((attachment, index) => (
                                    <tr>
                                        <td key={'attachment' + index}>
                                            <a rel='noreferrer' href={process.env.REACT_APP_AWS_URL + "goods-receives/" + attachment.attachmentPath}
                                                className="fs-6 text-hover-primary fw-bold" target="_blank">{attachment.attachmentName}</a>
                                            <div className="text-gray-400">{getReadableFileSizeString(attachment.fileSize)}</div>
                                        </td>
                                        <td>{attachment.creator.firstName + ' ' + attachment.creator.lastName + ' at ' + attachment.createdAt}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <Dropzone
                            styles={{ dropzone: { border: "none" } }}
                            accept='image/*,audio/*,application/pdf'
                            onSubmit={handleFileSubmit}
                        />
                    </div>
                </div>
            </Col>
            <Col md={8} className="pt-2">

                <div className="card card-flush overflow-hidden m-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">
                                {purchaseInfo?.po?.purpose === 'Finished Product' ? 'Products' : 'Items'}
                            </span>
                        </h3>
                    </div>
                    <div className="card-body pt-0">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>SL No</th>
                                    <th>{purchaseInfo?.po?.purpose === 'Finished Product' ? 'Product' : 'Item'}</th>
                                    <th>{purchaseInfo?.po?.purpose === 'Finished Product' ? 'Product Code' : 'Item Code'}</th>
                                    <th>{purchaseInfo?.po?.purpose === 'Finished Product' ? 'Packing' : 'Item Category'}</th>
                                    <th className='text-center'>Received Quantity</th>
                                    <th className='text-center'>Returned Quantity</th>
                                    {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                        <>
                                            <th className='text-center'>Rate</th>
                                            <th className='text-center'>Amount</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>

                                {purchaseInfo?.rows?.map((purchaseItem, index) => {
                                    const isFinishedProduct = purchaseInfo?.po?.purpose === 'Finished Product';
                                    const displayName = isFinishedProduct
                                        ? (purchaseItem?.product?.productName || purchaseItem?.item?.itemName || '')
                                        : (purchaseItem?.item?.itemName || '');
                                    const displayCode = isFinishedProduct
                                        ? (purchaseItem?.product?.productCode || '')
                                        : (purchaseItem?.item?.itemCode || '');
                                    const displayMeta = isFinishedProduct
                                        ? (purchaseItem?.product?.packing || '')
                                        : (purchaseItem?.item?.item_category?.categoryName || purchaseItem?.item?.itemCategory?.categoryName || '');
                                    const unitName = isFinishedProduct
                                        ? (purchaseItem?.product?.item?.unit?.unitName || purchaseItem?.item?.unit?.unitName || '')
                                        : (purchaseItem?.item?.unit?.unitName || '');

                                    return (
                                    <tr key={'item' + index}>
                                        <td>{index + 1}</td>
                                        <td>{displayName}</td>
                                        <td>{displayCode}</td>
                                        <td>{displayMeta}</td>
                                        <td className='text-center'>
                                            <span className="badge badge-light-danger"> {Number(purchaseItem?.quantity) + ' ' + unitName}</span>
                                        </td>
                                        <td className='text-center'>
                                            <span className="badge badge-light-warning"> {Number(purchaseItem?.returnQuantity || 0) + ' ' + unitName}</span>
                                        </td>
                                        {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                            <>
                                                <td className='text-end'>{Number(purchaseItem?.rate)}</td>
                                                <td className='text-end'>{numberFormat(purchaseItem?.quantity * purchaseItem?.rate)}</td>
                                            </>
                                        )}
                                    </tr>
                                    );
                                })}
                                {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                    <tr>
                                        <td colSpan={7} className='text-end'><b>Total Amount : </b></td>
                                        <td className='text-end'><b>{numberFormat(Number(purchaseInfo?.itemAmount || purchaseInfo?.purchaseAmount))}</b></td>
                                    </tr>
                                )}
                            </tbody>

                        </Table>
                        <div className='row mt-4'>
                            <div className='col-6'></div>
                            <div className='col-6'>
                                {(purchaseInfo?.vat || purchaseInfo?.tax) && (
                                    <div className='notice bg-light-primary rounded border-primary border border-dashed h-lg-100 p-6'>
                                        <div className="row mt-2">
                                            <div className="col-md-8 text-end"><strong>Total Amount: </strong></div>
                                            <div className="col-md-4 text-end">
                                                {numberFormat(purchaseInfo?.itemAmount || purchaseInfo?.purchaseAmount)}
                                            </div>
                                        </div>
                                        {purchaseInfo?.vat !== undefined && purchaseInfo?.vat > 0 && (
                                            <div className="row mt-2">
                                                <div className="col-md-8 text-end"><strong>VAT ({purchaseInfo.vat}%): </strong></div>
                                                <div className="col-md-4 text-end">
                                                    {numberFormat(purchaseInfo.vatAmount || 0)}
                                                </div>
                                            </div>
                                        )}
                                        {purchaseInfo?.tax !== undefined && purchaseInfo?.tax > 0 && (
                                            <div className="row mt-2">
                                                <div className="col-md-8 text-end"><strong>TAX ({purchaseInfo.tax}%): </strong></div>
                                                <div className="col-md-4 text-end">
                                                    {numberFormat(purchaseInfo.taxAmount || 0)}
                                                </div>
                                            </div>
                                        )}
                                        <div className="row mt-2">
                                            <div className="col-md-8 text-end"><strong>Net Amount: </strong></div>
                                            <div className="col-md-4 text-end">
                                                {numberFormat(purchaseInfo?.purchaseAmount || 0)}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='row mt-4'>
                            <div className='col text-center'>

                                <Link className="btn btn-info btn-sm" to={`/purchase`}>
                                    <KTSVG
                                        path='/media/svg/icons/Media/Back.svg'
                                        className='svg-icon-5 svg-icon'
                                    />		Back to Goods Receive List
                                </Link>

                            </div>
                        </div>

                    </div>
                </div>
            </Col>
        </Row>
    </>
    )
}

export default PurchaseDetails
